export default class MediaThumbnailGenerator {
  media = null;
  constructor(media) {
    this.media = media;
  }

  getThumbnail() {
    switch (this.media.type) {
      case 'file':
        return this.getFileThumbnail();
      case 'video':
        return this.getVideoThumbnail();
      case 'folder':
        return this.getFolderThumbnail();
      case 'collection':
        return this.getCollectionThumbnail();
    }
  }

  getVideoThumbnail() {
    return this.media.thumbnail_medium || '/img/thumbnail-loading.jpg';
  }

  getFolderThumbnail() {
    return 'fa-folder';
  }

  getFileThumbnail() {
    let ext = this.getFileExtension();

    switch (ext) {
      case 'pdf':
        return 'fa-file-pdf';
      case 'doc':
      case 'docx':
        return 'fa-file-word';
      case 'ppt':
      case 'pptx':
        return 'fa-file-powerpoint';
      case 'xls':
      case 'xlsx':
        return 'fa-file-excel';
      case 'csv':
        return 'fa-file-csv';
      case 'zip':
      case 'rar':
        return 'fa-archive';
      case 'png':
      case 'jpeg':
      case 'jpg':
      case 'heic':
      case 'svg':
      case 'gif':
        return 'fa-file-image';
      case 'txt':
        return 'fa-file-alt';
      default:
        return 'fa-file';
    }
  }

  getCollectionThumbnail() {
    return 'fa-folder-open';
  }

  getFileExtension() {
    let extension = '';
    if (this.media.url.download !== null) {
      extension = this.media.url.download.split('#').shift().split('?').shift().split('/').pop().split('.').pop().toLowerCase();
    }

    return extension;
  }
}
